export default {
  en: {
    titleLineOne: 'Welcome',
    titleLineTwo: 'Back',
  },
};
